import React, { ReactNode } from "react";
import {
  AppDefinedVariables,
  Data,
  DataDefinedVariables,
  OrganizedVariables,
} from "../textInterfaces";
import { isHyperlinkVariable, isNumStringVariable } from "./variableTypeCheck";

import { createMarkup } from "./createMarkup";
import { getValue } from "./getValue";
import { MarkupTheme } from "./styled";

export const replaceHyperlinkVariables = (
  component: Data,
  isFormHint: boolean,
  appDefinedVariables?: AppDefinedVariables,
): ReactNode => {
  const { variables, text } = component;

  if (variables !== undefined) {
    const organizedVariables =
      replaceNumStringVariablesAndOrganizeHyperlinkVariables(
        variables,
        text,
        appDefinedVariables,
      );

    return organizedVariables ? (
      <MarkupTheme>
        {createMarkup(
          organizedVariables.componentText,
          organizedVariables.linkVariables,
          isFormHint,
        )}
      </MarkupTheme>
    ) : (
      <span></span>
    );
  }

  return <span></span>;
};

export const replaceNumStringVariablesAndOrganizeHyperlinkVariables = (
  variables: DataDefinedVariables,
  text: string,
  appDefinedVariables?: AppDefinedVariables,
): OrganizedVariables | undefined => {
  return Object.entries({ ...variables, ...appDefinedVariables }).reduce(
    (acc, variable) => {
      const [name, values] = variable;

      if (
        typeof values === "string" ||
        typeof values === "number" ||
        isNumStringVariable(values)
      ) {
        const re = new RegExp(`{{${name}}}`);
        const textValue = getValue(
          name,
          values,
          "fallback",
          appDefinedVariables,
        );

        return {
          ...acc,
          componentText: acc.componentText.replace(re, textValue),
        };
      } else if (isHyperlinkVariable(values)) {
        const linkText = getValue(name, values, "text", appDefinedVariables);
        const linkUrl = getValue(name, values, "url", appDefinedVariables);

        return {
          ...acc,
          linkVariables: {
            ...acc.linkVariables,
            [name]: { text: linkText, url: linkUrl },
          },
        };
      }
    },
    { componentText: text, linkVariables: {} },
  );
};
